import { configureStore } from "@reduxjs/toolkit";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage"; // Defaults to localStorage for web
import { combineReducers } from "redux";
import userReducer from "./reducers/userReducer"; // Assuming the user slice is created separately
import userDetailReducer from "./reducers/userDetailReducer";
import userPhoneDetailReducer from "./reducers/userPhoneNoDetailReducer";

// Config for Redux Persist to persist only the user slice
const persistConfig = {
  key: "authUser",
  storage,
  whitelist: ["auth"], // only persist auth slice
};

const rootReducer = combineReducers({
  auth: userReducer,
  userDetail: userDetailReducer,
  userPhoneNoDetail: userPhoneDetailReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export const store = configureStore({
  reducer: persistedReducer,
});

export const persistor = persistStore(store);

// Export types for the store
export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
